import {
  Component, OnInit, OnDestroy
} from '@angular/core';
import {
  ActivatedRoute, Router
} from '@angular/router';
import {
  FormGroup, FormArray, FormBuilder, Validators, ValidatorFn, ValidationErrors, FormControl
} from '@angular/forms';
import { IPrescriptionTxReqRx } from 'app/shared/model/prescription-tx-req-rx.model';
import AccountService from 'app/core/auth/account.service';
import { HttpResponse } from '@angular/common/http';
import moment from 'moment';
import {
  DateValidator, CheckFutureDate
} from 'app/shared/util/request-util';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgbDateStruct, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { isIEBrowser } from 'app/app.constants';
import ProfileRxService from '../profile-rx/profile-rx.service';
import PrescriptionRxService from '../prescription-rx/prescription-rx.service';
import PrescriptionTxReqRxService from './prescription-tx-req-rx.service';

@Component({
  selector: 'jhi-prescription-tx-req-rx',
  templateUrl: './prescription-tx-req-rx.component.html',
  styleUrls: ['prescription-tx-req-rx.component.scss']
})
export default class PrescriptionTxReqRxComponent implements OnInit, OnDestroy {
  prescriptionTxReqs: IPrescriptionTxReqRx[];

  transPrescriptionForm: FormGroup;

  error;

  success;

  message;

  isSubmitted: any;

  showMessage: any;

  showErrorMessage: any;

  pharmacyList: any;

  transferPrescriptionData: any;

  dependentList: any[];

  showCount: any;

  pharmacyName: any;

  transferPrescriptionPayload: any;

  planholderId: any;

  showDropDown: any;

  targetPharmacy: any;

  isUnauthorized: boolean;

  maxDt: any;

  now: Date;

  rxPatientId: string;

  peopleSoftId: any;

  patientName: any;

  strDrugNameArray: any;

  detailObj = [];

  firstName: any;

  lastName: any;

  patientDob: string;

  primaryPhoneNumber: any;

  today: Date;

  defaultPharmacyId;

  // primaryEmailAddress;
  //
  // shippingAddress;

  slideScreen;

  isApicalled = false;

  showLoader = true;

  showLoggedInPhone = false;

  nameValidationPattern = "^[a-zA-Z\\'\\-]+\\s+[a-zA-Z\\'\\-\\s]+$";

  private componentDestroyed: Subject<void> = new Subject<void>();

  maxDate: NgbDateStruct;

  get addPatient() {
    return this.transPrescriptionForm.get('addPatient') as FormArray;
  }

  constructor(
    private formBuilder: FormBuilder,
    protected prescriptionTxReqService: PrescriptionTxReqRxService,
    protected prescriptionService: PrescriptionRxService,
    protected accountService: AccountService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    private profileService: ProfileRxService,
    private config: NgbDatepickerConfig
  ) {
    this.dependentList = [];
    this.maxDate = this.config.maxDate;
  }

  ngOnInit() {
    this.accountService.slideScreen.pipe(takeUntil(this.componentDestroyed)).subscribe((data) => {
      this.slideScreen = data;
    });
    this.now = new Date();
    this.maxDt = { year: this.now.getFullYear(), month: this.now.getMonth() + 1, day: this.now.getDate() };
    this.isSubmitted = false;
    this.showCount = false;
    this.showMessage = false;
    this.showErrorMessage = false;
    this.today = new Date();
    if (this.isAuthenticated()) {
      this.getAccountIdentity();
    }
    this.getPharmacyList();
    this.transPrescriptionForm = this.formBuilder.group({
      sourcePharmacyName: ['', Validators.required],
      sourcePharmacyPhoneNumber: ['', [Validators.required, Validators.minLength(14)]],
      selectPharmacy: ['', Validators.required],
      addPatient: this.formBuilder.array(this.isAuthenticated() ? [this.addLoggedPatientFormGroup()] : [this.addPatientFormGroup()])
    });
  }

  getPharmacyList() {
    this.prescriptionTxReqService.getPharmacyList()
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res: HttpResponse<[]>) => {
        if (res.body) {
          this.pharmacyList = (res.body as { [key: string]: any }[])
            .filter((pharmacy) => pharmacy.isAdultTransfer === true);
        }
      });
  }

  getAccountIdentity() {
    this.accountService.identity().then((accountInfo) => {
      this.peopleSoftId = accountInfo.peopleSoftId;
      this.rxPatientId = accountInfo.enterpriseRxPatientId.toString(10);
      this.firstName = accountInfo.firstName;
      this.lastName = accountInfo.lastName;
      if (this.rxPatientId) {
        this.getRxProfile(this.rxPatientId);
      }
      if (this.peopleSoftId) {
        this.getDependentList();
      }
      this.showLoggedInPhone = true;
    });
  }

  getRxProfile(patientId: string) {
    this.profileService.getProfile(parseInt(patientId, 10))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res:any) => {
        this.primaryPhoneNumber = res?.primaryContactDetails;
        this.defaultPharmacyId = res?.defaultPharmacyId;
        this.patientDob = res?.dateOfBirth;
      });
  }

  getDependentList() {
    this.prescriptionService
      .getDependentList(this.peopleSoftId)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((resp) => {
        this.dependentList = resp;
        this.dependentList.forEach((element) => {
          if (element.sequence === null) {
            this.planholderId = element.id;
          }
        });
        this.addPatient.controls[0].get('dependentId').setValue(this.planholderId);
        if (this.dependentList.length > 0) {
          this.showDropDown = true;
        }
      });
  }

  checkIsIEBrowser() {
    return isIEBrowser;
  }

  addAnotherPatient(): void {
    this.showCount = true;
    this.isSubmitted = false;
    if (this.isAuthenticated()) {
      this.addPatient.push(this.addLoggedPatientFormGroup());
    } else {
      this.addPatient.push(this.addPatientFormGroup());
    }
  }

  public validateForm: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const { controls } = control;
    if (controls) {
      const theOne = Object.keys(controls).findIndex((key) => controls[key].value.rxNumber !== '');

      if (theOne === -1) {
        return {
          atLeastOneRequired: {
            text: 'Please enter prescription number.'
          }
        };
      }

      const drugEntered = Object.keys(controls).findIndex(
        (key) => controls[key].value.rxNumber !== '' && controls[key].value.drugName === ''
      );

      if (drugEntered >= 0) {
        return {
          atLeastOneRequired: {
            text: 'Please enter drug name.'
          }
        };
      }
    }
  };

  public validatePhoneNumber: ValidatorFn = (control: FormControl): ValidationErrors | null => {
    if (control.value) {
      const phoneNumber = control.value;
      if (phoneNumber.length !== 14 && control.dirty) {
        return {
          lengthRequired: {
            text: 'Please enter valid phone number'
          }
        };
      }
    }
  };

  addRxNumbersForm() {
    const rxNumberFormArr = this.formBuilder.array<FormGroup>([], { validators: this.validateForm });
    for (let i = 0; i < 5; i++) {
      const fg = this.formBuilder.group({ rxNumber: ['', Validators.maxLength(20)], drugName: [''] });
      rxNumberFormArr.push(fg);
    }
    return rxNumberFormArr;
  }

  addMorePrescriptions(addPatient) {
    const start = addPatient.controls.rxNumberArr.controls.length;
    const end = addPatient.controls.rxNumberArr.controls.length + 5;
    for (let i = start; i < end; i++) {
      const fg = this.formBuilder.group({ rxNumber: [''], drugName: [''] });
      addPatient.controls.rxNumberArr.push(fg);
    }
  }

  addPatientFormGroup(): FormGroup {
    return this.formBuilder.group({
      /* Pattern requires at least one space, allows hyphens and apostrophes */
      guestPatientName: [
        '',
        [Validators.required, Validators.minLength(3), Validators.maxLength(40), Validators.pattern(this.nameValidationPattern)]
      ],
      guestPatientDob: ['', [Validators.required, DateValidator(), CheckFutureDate()]],
      guestPrimaryPhoneNumber: ['', [Validators.required, Validators.minLength(14)]],
      rxNumberArr: this.addRxNumbersForm()
    });
  }

  addLoggedPatientFormGroup(): FormGroup {
    return this.formBuilder.group({
      dependentId: [''],
      rxNumberArr: this.addRxNumbersForm(),
      primaryPhoneNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(14), this.validatePhoneNumber]]
    });
  }

  isAuthenticated() {
    return this.accountService.isAuthenticated();
  }

  transferPrescription() {
    this.isSubmitted = true;
    this.showLoader = false;
    if (this.transPrescriptionForm.invalid) {
      this.handleFormErrors();
    }
    if (!this.transPrescriptionForm.invalid) {
      this.buildDataForTransferRequest();
    }
  }

  buildDataForTransferRequest() {
    this.transferPrescriptionPayload = this.transPrescriptionForm.value;
    this.transferPrescriptionData = this.transPrescriptionForm.value;
    for (let i = 0; i < this.pharmacyList.length; i++) {
      if (this.pharmacyList[i]?.pharmacyId === parseInt(this.transferPrescriptionData?.selectPharmacy, 10)) {
        this.targetPharmacy = this.pharmacyList[i].name;
      }
    }
    const patientData = this.transPrescriptionForm.value.addPatient;

    patientData.forEach((element) => {
      const strArray = [];
      const drugArray = [];
      const rxStrArray = [];
      element.userType = this.isAuthenticated() ? 'loggedInUser' : 'guestUser';
      element.sourcePharmacyName = this.transferPrescriptionPayload?.sourcePharmacyName;
      element.sourcePharmacyPhoneNumber = this.transferPrescriptionPayload?.sourcePharmacyPhoneNumber;
      element.targetPharmacyId = this.transferPrescriptionPayload?.selectPharmacy;
      element.createdBy = 'string';
      element.emailSentFlag = true;
      element.requestId = 0;
      element.transferRequestDate = moment(new Date()).format('YYYY-MM-DD');
      element.peoplesoftId = this.peopleSoftId;
      Object.keys(element).forEach((key) => {
        if (key === 'rxNumberArr') {
          Object.keys(element[key]).forEach((k) => {
            if (element[key][k].rxNumber !== '' && element[key][k].drugName !== '') {
              strArray.push(element[key][k].rxNumber);
              if (element[key][k].drugName !== '') {
                drugArray.push(element[key][k].drugName);
              }
              rxStrArray.push(`${element[key][k].rxNumber} - ${element[key][k].drugName}`);
            }
          });
        } else if (key === 'guestPatientDob') {
          element.dateOfBirth = moment(element[key]).format('YYYY-MM-DD');
          delete element.guestPatientDob;
        } else if (key === 'guestPatientName') {
          element.patientName = element[key];
          delete element.guestPatientName;
        } else if (key === 'guestPrimaryPhoneNumber' || key === 'primaryPhoneNumber') {
          element.patientPhoneNumber = element[key];
          delete element.guestPrimaryPhoneNumber;
        }
      });
      this.strDrugNameArray = strArray;

      element.strDrugNamePrescription = [];
      element.strDrugNamePrescription = drugArray.reduce((result, field, index) => {
        result[strArray[index]] = field;
        return result;
      }, {});

      element.prescriptionNumberWithStoreId = strArray.join();
      element.drugName = drugArray.join();
      delete element.rxNumberArr;

      if (this.isAuthenticated()) {
        // THERE IS NO DOB INPUT FOR AUTHENTICATED USERS
        if (this.dependentList.length > 0) {
          const patientSequence = this.dependentList.filter((dependent) => parseInt(element.dependentId, 10) === dependent.id);

          element.sequence = patientSequence[0].sequence;
          element.patientId = patientSequence[0].patientId;
          element.patientName = `${patientSequence[0].firstName} ${patientSequence[0].lastName}`;
          element.dateOfBirth = moment(patientSequence[0].birthDate).format('YYYY-MM-DD');
        } else {
          element.sequence = null;
          element.dateOfBirth = this.patientDob;
          element.patientName = `${this.firstName} ${this.lastName}`;

          if (this.rxPatientId === null || this.rxPatientId === 'null') {
            element.patientId = '0';
          } else {
            element.patientId = this.rxPatientId;
          }
        }
      } else {
        element.patientId = '0';
      }
    });
    this.detailObj = JSON.parse(JSON.stringify(patientData));

    if (this.isApicalled === false) {
      this.sendTransferRequest();
    }
  }

  handleFormErrors() {
    if (!this.isAuthenticated()) {
      this.addPatient.controls.forEach((control) => {
        if (
          control.get('guestPatientDob').errors &&
          !control.get('guestPatientDob').errors?.required &&
          !control.get('guestPatientDob').errors?.invalidDate &&
          !control.get('guestPatientDob').errors?.futuredate
        ) {
          control.get('guestPatientDob').setErrors(null);
        }
      });
    }
    // removes error for hidden phone number field when more than one patient
    // is added to transfer request while user is logged in
    if (this.isAuthenticated()) {
      this.addPatient.controls.forEach((control) => {
        if (control.get('primaryPhoneNumber').pristine) {
          control.get('primaryPhoneNumber').setErrors(null);
        }
      });
    }
  }

  sendTransferRequest() {
    this.isApicalled = true;
    const prescriptionTxReq = this.transPrescriptionForm.value.addPatient;
    if (prescriptionTxReq.patientId === 'null' || prescriptionTxReq.patientId === '') {
      prescriptionTxReq.patientId = this.rxPatientId;
    }
    this.prescriptionTxReqService.transferPrescriptions(prescriptionTxReq)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe({
        next: () => {
          this.isApicalled = false;
          this.showMessage = true;
          this.showErrorMessage = false;
          this.showLoader = true;
        },
        error: () => {
          this.isApicalled = false;
          this.showMessage = false;
          this.showErrorMessage = true;
          this.showLoader = true;
        }
      });
  }

  changeDateFormat(date) {
    return moment(date).format('L');
  }

  calculateAge(addPatient) {
    this.isUnauthorized = false;
    this.dependentList.forEach((ele) => {
      let age = 0;
      if (parseInt(ele.dependentId, 10) !== this.planholderId && ele.id === parseInt(addPatient.value.dependentId, 10)) {
        age = moment().diff(ele.birthDate, 'month');
        if (age / 12 < 18) {
          return true;
        }
        addPatient.get('dependentId').setErrors({ dependentNotMinor: 'error' });
        return false;
      }
    });
  }

  removePatient(i) {
    this.addPatient.removeAt(i);
  }

  resetForm(failed) {
    this.showErrorMessage = false;
    this.showLoader = false;
    this.showErrorMessage = false;
    this.showMessage = false;
    this.isSubmitted = false;
    if (!failed) {
      this.transPrescriptionForm.reset();
    }
    if (this.isAuthenticated()) {
      this.addPatient.controls[0].get('dependentId').setValue(this.planholderId);
    }
    this.transPrescriptionForm.get('selectPharmacy').setValue('');
  }

  public ngOnDestroy(): void {
    this.componentDestroyed.next();
    this.componentDestroyed.unsubscribe();
  }
}
